import React from 'react'
import {isEmpty} from 'lodash'
import {Redirect} from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'
import ActionCompareArrows from 'material-ui-legacy/svg-icons/action/compare-arrows'
import ActionCheckCircle from 'material-ui-legacy/svg-icons/action/check-circle'
import {deepOrange500, lightGreenA700} from 'material-ui-legacy/styles/colors'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import AgencyProducerForm from './AgencyProducerForm'

import Resource from '../../stores/resource'
const AgProducerStore = Resource('agency-producers')

class EditAgencyProducer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      agencyProducer: (this.props.agencyProducer || {}),
      changed: false,
      saved: false,
      error: '',
      snackbarMessage: ''
    }
  }

  _save = (attributes) => {
    // Adjust attributes
    attributes.phones = {
      office: attributes.officePhone,
      mobile: attributes.mobilePhone
    }
    attributes.companyId = attributes.agencyId // TODO: fix this server-side
    // Remove display-only fields
    delete attributes.agencyName
    delete attributes.mobilePhone
    delete attributes.officePhone
    // Build new full name
    const newFullName = `${attributes.firstName} ${attributes.lastName}`
    // Update!
    AgProducerStore.update(this.state.agencyProducer.id, attributes)
    .then((result) => {
      this.setState({
        saved: true,
        changed: false,
        error: '',
        result: result,
        snackbarMessage: `External project manager "${newFullName}" saved!`
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _changed = (didChange) => this.setState({changed: didChange, saved: false})

  _closeErrorDialog = () => this.setState({error: ''})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect}/>

    const agencyProducer = (isEmpty(this.state.agencyProducer)) ? null : this.state.agencyProducer

    const changed = this.state.changed
    const saved = this.state.saved

    return (
      <section>
        <AgencyProducerForm
          formTitle={
            <span>
              {agencyProducer.attributes.fullName}&nbsp;
              {changed && <ActionCompareArrows color={deepOrange500}/>}
              {saved && <ActionCheckCircle color={lightGreenA700}/>}
            </span>
          }
          agencyProducer={agencyProducer}
          changedCallback={this._changed}
          submitCallback={this._save}
          cancelCallback={() => this._redirectTo("/agency-producers")}
        />

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't save your changes">
          <p>
            The external project manager <strong>
              {agencyProducer.attributes.fullName}
            </strong> remains unchanged.
          </p>
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditAgencyProducer



// WEBPACK FOOTER //
// ./src/components/AgencyProducers/EditAgencyProducer.jsx